import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getLatestArticlesSourceToken;
let getArticlesSourceToken;
let getWorkflowSourceToken;

export const getLatestArticles = ({
  token,
  limit,
  offset = 0,
  language = "fr",
  communitiesId = [],
  search = null,
  sourceToken = null,
  conditions = []
}) => {
  getLatestArticlesSourceToken = updateSourceToken(
    getLatestArticlesSourceToken,
    sourceToken
  );

  const filter = [
    {
      property: "status",
      value: "PUBLISHED",
      operator: "like"
    },
    {
      property: "language",
      value: language,
      operator: "like"
    }
  ];

  if (communitiesId.length > 0) {
    filter.push({
      property: "organization.id",
      value: communitiesId,
      operator: "in"
    });
  }
  if (search) {
    filter.push({
      property: "word",
      operator: "like",
      value: search
    });
  }

  const sort = [
    {
      property: "publishedAt",
      dir: "desc"
    }
  ];
  const fields = [
    "*",
    "url",
    "author",
    "introduction",
    "main_media",
    "tags",
    "category",
    "image_reduced",
    "organization",
    "avatars",
    "albums"
  ];
  const requestUrl = `${TTP_API_URL}/blog/article/with-other-resources`;

  return axios
    .get(requestUrl, {
      cancelToken: getLatestArticlesSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify([...filter, ...conditions]),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit,
        start: offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getArticles = ({
  token,
  limit,
  language = "fr",
  communityId,
  offset = 0,
  search = null,
  isPublic = true,
  sourceToken = null,
  conditions = [],
  loggedAs = "GUEST"
}) => {
  getArticlesSourceToken = updateSourceToken(
    getArticlesSourceToken,
    sourceToken
  );
  const filter = [
    {
      property: "status",
      value: "PUBLISHED",
      operator: "like"
    },
    {
      property: "language",
      value: language,
      operator: "like"
    } /*,
    {
      property: "isPrivate",
      value: 0,
      operator: "eq"
    } */,
    {
      property: "isExternal",
      value: 0,
      operator: "eq"
    }
  ];

  /*let csScope = ["INTRA_SHARE", "EXTRA_SHARE", "INTRA_CROSS", "EXTRA_CROSS"];

  switch (loggedAs) {
    case "CLIENT":
      // TODO: activer INTRA_CROSS Aprés démo du 29/05/2020 avec PDG UP
      csScope = [...["EXTRA_SHARE", "INTRA_CROSS", "EXTRA_CROSS"]];
      break;
    default:
  }*/

  filter.push({
    property: "csScope",
    value: "PUBLIC",
    operator: "in"
  });

  if (communityId) {
    filter.push({
      property: "organization.id",
      value: communityId,
      operator: "eq"
    });
  }
  if (search) {
    filter.push({
      property: "word",
      operator: "like",
      value: search
    });
  }

  const sort = [
    {
      property: "publishedAt",
      dir: "desc"
    }
  ];
  const fields = [
    "*",
    "url",
    "author",
    "introduction",
    "main_media",
    "tags",
    "category",
    "image_reduced",
    "organization",
    "avatars",
    "albums"
  ];
  if (isPublic) {
    fields.push("content", "contentState");
  } else {
    fields.push("social");
  }
  const requestUrl = `${TTP_API_URL}/blog/article`;

  return axios
    .get(requestUrl, {
      //cancelToken: getArticlesSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify([...filter, ...conditions]),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit,
        start: offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getWorkflow = ({
  token,
  limit,
  language = "fr",
  communityId,
  offset = 0,
  sourceToken = null
}) => {
  getWorkflowSourceToken = updateSourceToken(
    getWorkflowSourceToken,
    sourceToken
  );
  const filter = [
    {
      property: "status",
      value: "PUBLISHED",
      operator: "like"
    },
    {
      property: "language",
      value: language,
      operator: "like"
    },
    {
      property: "isExternal",
      value: 1,
      operator: "eq"
    }
  ];

  if (communityId) {
    filter.push({
      property: "organization.id",
      value: communityId,
      operator: "eq"
    });
  }

  const sort = [
    {
      property: "publishedAt",
      dir: "desc"
    }
  ];
  const fields = [
    "*",
    "url",
    "creator",
    "introduction",
    "main_media",
    "category",
    "image_reduced",
    "organization",
    "avatars",
    "social"
  ];
  const requestUrl = `${TTP_API_URL}/blog/article`;

  return axios
    .get(requestUrl, {
      cancelToken: getWorkflowSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify(filter),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit,
        start: offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getSingleArticle = (token, articleId) => {
  const filter = [
    { property: "id", value: articleId, operator: "eq" },
    {
      property: "status",
      value: ["DRAFT", "READY", "SCHEDULED", "PUBLISHED"],
      operator: "in"
    }
  ];

  const fields = [
    "*",
    "content",
    "contentState",
    "introduction",
    "author",
    "contactEmail",
    "author.avatar",
    "main_media",
    "tags",
    "category",
    "organization",
    "media_articles",
    "image_cropped",
    "comment",
    "url",
    "avatars",
    "social",
    "albums"
  ];

  const requestUrl = `${TTP_API_URL}/blog/article`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        fields: fields.join(","),
        filter: JSON.stringify(filter)
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/article.js